import { styled } from '@mui/material/styles';
import TableRow from '@mui/material/TableRow';

export const StyledTableRow = styled(TableRow)({
  cursor: 'pointer'
});



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpPluginsTable/styles.js